//import Uiconstants from "../../lib/UIconstants"
import { isDesktop } from 'react-device-detect';
import CloseController from '../../controllers/CloseController';
import FastspindialogueController from '../../controllers/fastspin_dialogue/FastspindialogueController';
import MainGridController from '../../controllers/grid/MainGridController';
import { COMPONENTS } from '../../lib/constants';
import { FastplayDialogueViewGrid } from './FastplayDialogueViewGrid';

let scale = isDesktop ? 1 : 2;
export const FastplayDialogueView = {
	name: COMPONENTS.FAST_PLAY_DIALOGUE,
	child: true,
	position: {
		x: 0,
		y: 0
	},
	controllers: [
		{
			Controller: CloseController,
			name: 'CloseController',
			config: {
				closeBtn: 'close',
				remove: true,
				holder: 'fast_play_holder'
			}
		},
		{
			Controller: FastspindialogueController,
			name: 'FastspindialogueController',
			config: {
				item: 'fsSprite',
				value: 'fsSprite',
				holder: 'fast_play_holder'
			}
		},
		{
			Controller: MainGridController,
			name: 'FastSpinDialogueGrid',
			config: FastplayDialogueViewGrid
		}
	],
	components: [
		{
			name: 'fast_play_holder',
			type: 'Sprite',
			components: [
				{
					name: 'bg',
					type: 'Sprite',
					img: 'fastspin_dialogue_bg',
					position: { x: 0, y: 0 },
					scale: { x: scale, y: scale }
				},
				{
					name: 'header',
					type: 'Text',
					text: 'FASTPLAY_DIALOGUE_TITLE',
					position: { x: 634 / 2, y: 60 },
					anchor: { x: 0.5, y: 0.5 }
				},
				{
					name: 'FASTPLAY_DIALOGUE_TEXT_1',
					type: 'Text',
					text: 'FASTPLAY_DIALOGUE_TEXT_1',
					position: { x: 60, y: 128 }
				},
				{
					name: 'FASTPLAY_DIALOGUE_TEXT_2',
					type: 'Text',
					text: 'FASTPLAY_DIALOGUE_TEXT_2',
					position: { x: 130, y: 160 }
				},
				{
					name: 'FASTPLAY_DIALOGUE_FAST_PLAY',
					type: 'Text',
					text: 'FASTPLAY_DIALOGUE_FAST_PLAY',
					position: { x: 390, y: 161 }
				},
				{
					name: 'FASTPLAY_DIALOGUE_NOTE',
					type: 'Text',
					text: 'FASTPLAY_DIALOGUE_NOTE',
					position: { x: 60, y: 240 }
				},
				{
					name: 'FASTPLAY_DIALOGUE_FAST_PLAY_SM',
					type: 'Text',
					text: 'FASTPLAY_DIALOGUE_FAST_PLAY_SM',
					position: { x: 390, y: 240 }
				},
				{
					name: 'FASTPLAY_DIALOGUE_NOTE_END',
					type: 'Text',
					text: 'FASTPLAY_DIALOGUE_NOTE_END',
					position: { x: 495, y: 240 }
				},
				{
					name: 'fsSprite',
					type: 'Sprite',
					position: { x: 190, y: 305 },
					components: [
						{
							name: 'fs',
							type: 'SwitchButton',
							position: { x: -5, y: 5 },
							bg: 'checkbox_active',
							fg: 'checkbox_inactive'
						},
						{
							name: 'fsText',
							type: 'Sprite',
							components: [
								{
									name: 'fstext',
									type: 'Text',
									position: { x: 30, y: 0 },
									text: 'FASTPLAY_DIALOGUE_TOGGLE'
								},
								{
									name: 'fstext',
									type: 'Text',
									position: { x: 135, y: 0 },
									text: 'FASTPLAY_DIALOGUE_FAST_PLAY'
								}
							]
						}
					]
				},
				{
					name: 'close',
					type: 'ActionButton',
					bg: 'notif_btn',
					text: 'FASTPLAY_DIALOGUE_BTN',
					position: { x: 315, y: 430 }
				}
			]
		}
	]
};
